import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';

const serverUrl = publishObjectPath.serverUrl;

export class InfoServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  public getList(opts: object) {
    const url = serverUrl + '/api/notify/system-announcement';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  public getInfo() {
    const url = serverUrl + '/api/notify/system-announcement/last-announcement-content';
    return this.rSerivce.serverObj.get(url);
  }
  public getNotifyReceiverList(opts: object) {
    const url = serverUrl + '/api/notify/notify-receiver';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  public getSysLogList(opts: object) {
    const url = serverUrl + '/api/sysManage/sysLog';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
}
